import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classNames from 'classnames';
var css = {
  "arrow-shrinked": "rui-sE1oV",
  "icon-shrinked": "rui-NWWzJ",
  "disabled-shrinked": "rui-L8Tth",
  "arrow-expanded": "rui-YjUoE",
  "icon-expanded": "rui-EoSoK",
  "disabled-expanded": "rui-PTkdc"
};
import Icon from '../Icon/Icon';
var Arrow = function Arrow(_ref) {
  var type = _ref.type,
    icon = _ref.icon,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    direction = _ref.direction,
    className = _ref.className,
    ariaLabel = _ref.ariaLabel;
  var classIcon = classNames(css["icon-".concat(type)], _defineProperty({}, css["disabled-".concat(type)], disabled));
  return /*#__PURE__*/React.createElement("div", {
    className: css["arrow-".concat(type)],
    onClick: onClick,
    onKeyPress: onClick,
    role: "button",
    tabIndex: 0,
    "aria-label": ariaLabel
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames(classIcon, className)
  }, /*#__PURE__*/React.createElement(Icon, {
    color: disabled ? 'blackDisabled' : 'black',
    icon: icon,
    size: 24,
    direction: direction
  })));
};
Arrow.defaultProps = {
  disabled: false,
  type: '',
  direction: 'ltr'
};
export default Arrow;